import React from 'react'

function ConvertKitEdm(props) {
  const { id } = props
  return (
    <div className="ConvertKitEdm" style={{ marginTop: 10, marginBottom: 10 }}>
      <div
        dangerouslySetInnerHTML={{
          __html: `<script async data-uid="${id}" src="https://pop-vibe.ck.page/${id}/index.js"></script>`,
        }}
      />
    </div>
  )
}

export default ConvertKitEdm
